const checkShippingMessageExpired = () => {
    const currentDate = new Date()
    const endDate = new Date(Date.UTC(2026, 6, 18, 4, 0, 0)) // July 18, 2026, 04:00 AM UTC (midnight ET)
    return currentDate >= endDate
}

const ShippingCopy = () => {
    return (
        <>
            {!checkShippingMessageExpired() && (
                <p>
                    To ensure same-day printing and shipping, please place
                    your order by 11:30 a.m. ET on Thursday, July 16 or
                    Friday, July 17. Orders placed after 11:30 a.m. ET will
                    ship the next business day.
                </p>
            )}
        </>
    )
}

export default ShippingCopy
